import 'common/css/app.css'
import './index.css'
import 'common/js/global.js'

$(function() {
  var ele1 = $('.num-wrapper').find('.num1')
  countUp(ele1,25000,0,1000,0)
  var ele2 = $('.num-wrapper').find('.num2')
  countUp(ele2,3000,0,1000,0)
  var ele3 = $('.num-wrapper').find('.num3')
  countUp(ele3,70000,0,1000,0)
})
function countUp(elem, endVal, startVal, duration, decimal) {
  var startTime = 0;
  var dec = Math.pow(10, decimal);
  var progress, value;

  function startCount(timestamp) {
      if (!startTime) startTime = timestamp;
      progress = timestamp - startTime;
      value = startVal + (endVal - startVal) * (progress / duration);
      value = (value > endVal) ? endVal : value;
      value = Math.floor(value * dec) / dec;
      elem.html(value.toFixed(decimal));
      progress < duration && requestAnimationFrame(startCount)
  }

  requestAnimationFrame(startCount)
}


// WEBPACK FOOTER //
// ./src/openPlatform/index.js